import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import { leftArrow, tableEye } from '../../common/Assets/imgs'
import { useLocation, useNavigate } from 'react-router-dom'
import MaterialTable from '../../Components/Table/MaterialTable'
import toast from 'react-hot-toast'
import { get, put } from '../../Services/ApiHandler'
import { URLS } from '../../Services/Constant'

const VehiclesTripHistory = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const STORAGE_KEYS = {
    transport: "tm_transport_context",
    vehicle: "tm_vehicle_context",
    type: "tm_context_type",
  };
  const readStorage = (key) => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  };
  const writeStorage = (key, value) => {
    try {
      if (value === undefined || value === null) return;
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      // ignore storage errors
    }
  };
  const [context, setContext] = useState(() => {
    const state = location.state || {};
    return {
      datas: state.datas ?? readStorage(STORAGE_KEYS.transport),
      type: state.type ?? readStorage(STORAGE_KEYS.type),
      data: state.data ?? readStorage(STORAGE_KEYS.vehicle),
    };
  });
  const { type, datas, data } = context;
  const [pagination, setPagination] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [loader, setLoader] = useState(false);

  const [adminList, setAdminList] = useState([]);

  console.log("datas", datas);


  const getList = async () => {
    if (!datas?.id) return;
    try {
      const response = await get(`${URLS.VEHICLE_TRIP_LIST}${datas?.id}/`);
      console.log("res", response);
      setAdminList(response?.data);
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    const state = location.state || {};
    if (state?.datas || state?.type || state?.data) {
      setContext((prev) => ({
        datas: state?.datas ?? prev.datas,
        type: state?.type ?? prev.type,
        data: state?.data ?? prev.data,
      }));
      if (state?.datas) writeStorage(STORAGE_KEYS.transport, state.datas);
      if (state?.type) writeStorage(STORAGE_KEYS.type, state.type);
      if (state?.data) writeStorage(STORAGE_KEYS.vehicle, state.data);
    }
  }, [location.state]);

  useEffect(() => {
    getList();
  }, [datas]);

  useEffect(() => {
    if (!datas?.id) {
      toast.error("Transport details missing. Please open from Transport Details.");
    }
  }, [datas]);

  const columns = [
    {
      header: "S.No",
      accessorFn: (row, index) => index + 1,
      id: "serial_no",

    },
    {
      accessorKey: "order_id",
      header: "Order ID",
    },
    {
      accessorKey: "pickup",
      header: "Pickup",
        Cell: ({ row }) => {
        const text = row.original.pickup || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "drop",
      header: "Drop",
        Cell: ({ row }) => {
        const text = row.original.drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "total_amount",
      header: "Trip Price",
    },
    {
      accessorKey: "date_time",
      header: "Date & Time",
    },
    {
      header: "Status",
      accessorKey: "status",
      // Cell: ({ cell, row }) => {
      //   const status = cell.getValue()?.toLowerCase();; // pending / delivered / completed

      //   let statusClass = "";
      //   let statusText = "";

      //   if (status === "pending") {
      //     statusClass = "pending-btn";
      //     statusText = "Pending";
      //   } else if (status === "delivered") {
      //     statusClass = "delivered-btn";
      //     statusText = "Delivered";
      //   } else if (status === "completed") {
      //     statusClass = "completed-btn";
      //     statusText = "Completed";
      //   }

      //   return (
      //     <button
      //       className={`border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 ${statusClass}`}
      //       onClick={() => statusChanger(row.original.id, status)}
      //     >
      //       {statusText}
      //     </button>
      //   );
      // },
    },
    // {
    //   id: "action", // ✅ important when no accessorKey
    //   header: "Action",
    //   Cell: ({ row }) => (
    //     <div onClick={() => navigation("/add-admin", {state: {data: row.original, type:"view"}})}>
    //       <img src={tableEye} alt="" className="tableeye" />
    //     </div>
    //   ),
    // },
  ];

  const tabs = [
    { name: "Vehicles Details", path: "/addvehicle-transport" },
    { name: "Vehicles Trip History", path: "/vehicle-triphistory" }
  ]

  const handleTabClick = (tab) => {
    if (datas) writeStorage(STORAGE_KEYS.transport, datas);
    if (type) writeStorage(STORAGE_KEYS.type, type);
    if (data) writeStorage(STORAGE_KEYS.vehicle, data);
    navigation(tab.path, { state: { datas, type, data } });
  };

  const statusChanger = (id, currentStatus) => {
    put(`${URLS.ADMIN_STATUS}${id}/`, {
      status: currentStatus === 1 ? 0 : 1,
    })

      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message);
          // getList(); // refresh table
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <>
      <Header />
      <div style={{ marginTop: "6rem", padding: "15px" }}>
        <div className="section">
          <h3 onClick={() => navigation(-1)} className="section-titlez">
            <img
              src={leftArrow}
              style={{ marginRight: 10 }}
              className="back-icon-arrow"
              alt=""
            />
            Vehicles
          </h3>
          {/* Tabs */}
          <div className="tabs mb-4 ms-3">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => handleTabClick(tab)}
                className={`tab-btn ${location.pathname === tab.path ? "active" : ""
                  }`}
              >
                {tab.name}
              </button>
            ))}

          </div>
        </div>

        <div>
          <MaterialTable rowCount={totalCount} pagination={pagination} columns={columns} data={adminList || []} setPagination={setPagination} loading={loader} />
        </div>

      </div>
    </>
  )
}

export default VehiclesTripHistory
